module.exports = __webpack_public_path__ + "static/img/gpsReports.6b080fb7.svg";